





















































































































import EventBus from '@/plugins/EventBus'
import { ConfirmacaoCirurgicaStatusEnum } from '@/types/interfaces/Solicitacao'
import { humanTime, maskPhone } from '@/utils/common'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeMapaCirurgicoStore from '../Backoffice/Store/BackofficeMapaCirurgicoStore'
import ConfirmacaoCirurgicaStore from './store/confirmacao-cirurgica-store'

@Component
export default class ModalConfirmacaoCirurgica extends Vue {
  isLoading = false

  mounted() {}

  destroyed() {}

  async closeModal() {
    try {
      this.showLoading()
      this.confirmacaoCirurgicaStore.setShowModalConfirmacaoCirurgica(false)
      this.confirmacaoCirurgicaStore.reset()
      await this.backofficeMapaCirurgicoStore.loadAgendamentosMedicoSearch()
    } finally {
      this.hideLoading()
    }
  }

  async gerarConfirmacaoDoPaciente() {
    try {
      this.isLoading = true
      this.showLoading()

      const res = await this.confirmacaoCirurgicaStore.gerarConfirmacao(
        'Paciente'
      )
      if (!res.success) {
        this.showToastError(res)
        return
      }

      this.showToastSuccessToSend()

      this.confirmacaoCirurgicaData.confirmacaoCirurgiaPaciente = {
        ...this.confirmacaoCirurgicaData.confirmacaoCirurgiaPaciente,
        status: ConfirmacaoCirurgicaStatusEnum.pendente,
        criadoEm: new Date().toISOString(),
      }
    } finally {
      this.hideLoading()
      this.isLoading = false
    }
  }

  async gerarConfirmacaoDoMedico() {
    try {
      this.isLoading = true
      this.showLoading()

      const res = await this.confirmacaoCirurgicaStore.gerarConfirmacao(
        'Medico'
      )
      if (!res.success) {
        this.showToastError(res)
        return
      }

      this.showToastSuccessToSend()

      this.confirmacaoCirurgicaData.confirmacaoCirurgiaMedico = {
        ...this.confirmacaoCirurgicaData.confirmacaoCirurgiaMedico,
        status: ConfirmacaoCirurgicaStatusEnum.pendente,
        criadoEm: new Date().toISOString(),
      }
    } finally {
      this.hideLoading()
      this.isLoading = false
    }
  }

  async confirmarPacienteManualmente() {
    try {
      this.isLoading = true
      this.showLoading()

      const res = await this.confirmacaoCirurgicaStore.confirmar('Paciente')
      if (!res.success) {
        this.showToastError(res)
        return
      }

      this.showToastSuccessToConfirm()

      this.confirmacaoCirurgicaData.confirmacaoCirurgiaPaciente = {
        ...this.confirmacaoCirurgicaData.confirmacaoCirurgiaPaciente,
        status: ConfirmacaoCirurgicaStatusEnum.confirmado,
        respondidoEm: new Date().toISOString(),
      }
    } finally {
      this.hideLoading()
      this.isLoading = false
    }
  }

  async confirmarMedicoManualmente() {
    try {
      this.isLoading = true
      this.showLoading()

      const res = await this.confirmacaoCirurgicaStore.confirmar('Medico')
      if (!res.success) {
        this.showToastError(res)
        return
      }

      this.showToastSuccessToConfirm()

      this.confirmacaoCirurgicaData.confirmacaoCirurgiaMedico = {
        ...this.confirmacaoCirurgicaData.confirmacaoCirurgiaMedico,
        status: ConfirmacaoCirurgicaStatusEnum.confirmado,
        respondidoEm: new Date().toISOString(),
      }
    } finally {
      this.hideLoading()
      this.isLoading = false
    }
  }

  showLoading() {
    EventBus.$emit('setLoadingRequest', {
      status: 'Carregando...',
      text: 'Carregando...',
    })
  }

  hideLoading() {
    EventBus.$emit('clearLoadingRequest')
  }

  showToastSuccessToConfirm() {
    EventBus.$emit('setSnackbar', {
      show: true,
      text: 'Confirmação realizada com sucesso!',
      icon: 'done',
      color: '#2E7D32',
    })
  }

  showToastSuccessToSend() {
    EventBus.$emit('setSnackbar', {
      show: true,
      text: 'Envio realizado com sucesso!',
      icon: 'done',
      color: '#2E7D32',
    })
  }

  showToastError(request: any) {
    EventBus.$emit('setSnackbar', {
      show: true,
      text: request.message || 'Não foi possível realizar a ação',
      icon: 'warning',
      color: '#C62828',
      timeout: 7500,
    })
  }

  get backofficeMapaCirurgicoStore() {
    return getModule(BackofficeMapaCirurgicoStore, this.$store)
  }

  get confirmacaoCirurgicaStore() {
    return getModule(ConfirmacaoCirurgicaStore, this.$store)
  }

  get confirmacaoCirurgicaData() {
    return this.confirmacaoCirurgicaStore.confirmacaoCirurgicaParam
  }

  get telefoneMedico() {
    return maskPhone(this.confirmacaoCirurgicaData.telefoneMedico || '')
  }

  get telefonePaciente() {
    return maskPhone(this.confirmacaoCirurgicaData.telefonePaciente || '')
  }

  get statusMensagemPaciente() {
    const confirmacaoData =
      this.confirmacaoCirurgicaData.confirmacaoCirurgiaPaciente
    if (confirmacaoData && confirmacaoData.status) {
      // eslint-disable-next-line default-case
      switch (confirmacaoData.status) {
        case ConfirmacaoCirurgicaStatusEnum.pendente:
          return `Pendente - ${humanTime(confirmacaoData.criadoEm!)}`

        case ConfirmacaoCirurgicaStatusEnum.confirmado:
          return `Confirmada - ${humanTime(confirmacaoData.respondidoEm!)}`

        case ConfirmacaoCirurgicaStatusEnum.recusado:
          return `Recusada - ${humanTime(confirmacaoData.respondidoEm!)}`
      }
    }

    return 'Não enviada'
  }

  get statusMensagemMedico() {
    const confirmacaoData =
      this.confirmacaoCirurgicaData.confirmacaoCirurgiaMedico
    if (confirmacaoData && confirmacaoData.status) {
      // eslint-disable-next-line default-case
      switch (confirmacaoData.status) {
        case ConfirmacaoCirurgicaStatusEnum.pendente:
          return `Pendente - ${humanTime(confirmacaoData.criadoEm!)}`

        case ConfirmacaoCirurgicaStatusEnum.confirmado:
          return `Confirmada - ${humanTime(confirmacaoData.respondidoEm!)}`

        case ConfirmacaoCirurgicaStatusEnum.recusado:
          return `Recusada - ${humanTime(confirmacaoData.respondidoEm!)}`
      }
    }

    return 'Não enviada'
  }

  // Permissions

  get canShowModal() {
    return this.confirmacaoCirurgicaStore.modal.confirmacaoCirurgica
  }

  get canShowPacienteButtons() {
    if (
      this.confirmacaoCirurgicaData.templateMapaCirurgico &&
      this.confirmacaoCirurgicaData.templateMapaCirurgico
        .confirmacaoCirurgiaPaciente
    ) {
      return true
    }
    return false
  }

  get canShowMedicoButtons() {
    if (
      this.confirmacaoCirurgicaData.templateMapaCirurgico &&
      this.confirmacaoCirurgicaData.templateMapaCirurgico
        .confirmacaoCirurgiaMedico
    ) {
      return true
    }
    return false
  }

  get canEnableConfirmarPacienteManualmenteBtn() {
    if (this.confirmacaoCirurgicaData.confirmacaoCirurgiaPaciente) {
      return (
        this.confirmacaoCirurgicaData.confirmacaoCirurgiaPaciente.status !==
        ConfirmacaoCirurgicaStatusEnum.confirmado
      )
    }

    return true
  }

  get canEnableConfirmarMedicoManualmenteBtn() {
    if (this.confirmacaoCirurgicaData.confirmacaoCirurgiaMedico) {
      return (
        this.confirmacaoCirurgicaData.confirmacaoCirurgiaMedico.status !==
        ConfirmacaoCirurgicaStatusEnum.confirmado
      )
    }

    return true
  }
}
